import get from 'lodash/get';
import set from 'lodash/set';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { ERROR_CODES } from '../../../constants/errors';

export default error => {
  if (
    !error ||
    get(error, 'meta.validationErrors.login[0].code') ===
      ERROR_CODES.ALREADY_ASSIGNED
  ) {
    return null;
  }

  return set({ ...error }, 'meta.validationErrors', {
    [PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE]: get(error, 'description'),
  });
};



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/transformDataErrors.js